import lrInputIcon from './_src/lrInputIcon.vue'

lrInputIcon.install = function(Vue) {
  Vue.component(lrInputIcon.name, lrInputIcon)
}

export default lrInputIcon